/**
 * Normalize API GET /digital-twin/scene into a Redux-friendly scene slice.
 *
 * Component placement is derived from the ordinal `position` and the camera is derived from a
 * fixed preset per surface, so neither geometry nor camera state crosses this boundary — only
 * the machine and the components/locations themselves.
 */
export function apiToSceneState(apiResponse) {
  if (!apiResponse) {
    return {
      machine: null,
      components: [],
      locations: [],
      conditions: { machine: null, components: {} },
    };
  }
  return {
    machine: apiResponse.machine || null,
    components: apiResponse.components || [],
    locations: apiResponse.locations || [],
    conditions: apiResponse.conditions || { machine: null, components: {} },
  };
}
